import React, {useState} from 'react'
import {Tabs} from '@therms/atalaya'
import {MdList, MdTask} from 'react-icons/md'
import {LocationTaskTodoList} from '@src/modules/Locations/components/ViewLocation/components/LocationTasks/components/LocationTaskTodoList.tsx'
import {LocationTaskList} from '@src/modules/Locations/components/ViewLocation/components/LocationTasks/components/LocationTaskList.tsx'
import {LocationTaskCompletionList} from '@src/modules/Locations/components/ViewLocation/components/LocationTasks/components/LocationTaskCompletionList.tsx'
import {FaHistory} from 'react-icons/fa'

export function LocationTasks() {
  const [tab, setTab] = useState('Todo')

  return (
    <div>
      <Tabs fullWidth pills onTabClick={setTab} currentKey={tab}>
        <Tabs.Tab title="Todo" icon={<MdTask size={16} />}>
          <LocationTaskTodoList />
        </Tabs.Tab>

        <Tabs.Tab title="History" icon={<FaHistory size={16} />}>
          <LocationTaskCompletionList />
        </Tabs.Tab>

        <Tabs.Tab title="Tasks" icon={<MdList size={16} />}>
          <LocationTaskList />
        </Tabs.Tab>
      </Tabs>
    </div>
  )
}
